define.alias("ember-composable-helpers/helpers/pipe-action", "settings/helpers/pipe-action");